import React, { useState } from 'react';

import atrato_logo from '../../../assets/atrato.png';
import coppelpay_logo from '../../../assets/coppelpay25.png';
import mp_logo from '../../../assets/MP_RGB_HANDSHAKE_color_horizontal.png';
import { RichButton } from '../../common/buttons';
import Loader from '../../common/loader';
import ShippingCosts, { pickUpMessageObject } from './shippingCost';
import { DeliveryTypes, PaymentTypes } from '../../../models/checkout_model';
import { CartProductItem, ShppingResponse } from '../../../models/cart_model';
import { ZoneItem } from '../../../models/branch_model';
import Survey from '../cart/survey';

type PaymentSectionProps = {
  selectPayemntType: any;
  payment_type: PaymentTypes | false;
  clickFun: any;
  loading: boolean;
  error_message: null | string;
  shippingcost: ShppingResponse;
  isDelivery: boolean;
  total: number;
  zeroPriceAlert?: boolean;
  removeZeroPriceProducts?: () => void;
};

type InfoSectionProps = {
  clickFun: any;
  loading: boolean;
  products: CartProductItem[];
  removeFun: any;
  shippingcost: ShppingResponse;
  branches: ZoneItem[];
  delivery_type: DeliveryTypes;
  changePriceAlert: any;
  zeroPriceAlert?: boolean;
  zip: string;
  onPickUpMsgChange: (msg: pickUpMessageObject) => void;
};

export const PaymentSection: React.FC<PaymentSectionProps> = ({
  selectPayemntType,
  payment_type,
  clickFun,
  loading,
  error_message,
  shippingcost,
  isDelivery,
  total,
  zeroPriceAlert = false,
  removeZeroPriceProducts,
}) => {
  if (loading || !shippingcost.shippingCosts) {
    return null;
  }
  return (
    <div className="payment_section">
      {zeroPriceAlert && removeZeroPriceProducts && (
        <div className="alert alert-warning text-dark">
          <p className="mb-2">Hay productos sin precio disponible para esta sucursal.</p>
          <button
            className="btn btn-danger btn-sm"
            onClick={removeZeroPriceProducts}
          >
            Quitar productos con conflicto
          </button>
        </div>
      )}
      <h4>Selecciona tu método de pago:</h4>
      <div className="btn_rich_container horizontal mob_full">
        <RichButton
          title="Paga con Mercado Pago"
          classes="mp_wallet_btn"
          value="mp_wallet"
          small={true}
          active={payment_type === 'mp_wallet'}
          clickFun={zeroPriceAlert ? undefined : selectPayemntType}
          disabled={zeroPriceAlert}
          id="click_payment_mp_wallet"
        >
          <img src={mp_logo} alt="Paga con Mercado Pago" style={{ maxWidth: '160px', width: '100%' }} />
        </RichButton>
        <RichButton
          title="Pago con Tarjeta de Crédito/Débito"
          classes="online_btn"
          icon="fa-fw far fa-credit-card"
          value="online"
          small={true}
          active={payment_type === 'online'}
          clickFun={zeroPriceAlert ? undefined : selectPayemntType}
          disabled={zeroPriceAlert}
          id="click_payment_online"
        />
        <RichButton
          title="Transferencia Bancaria"
          classes="transfer_btn"
          icon="fa-fw fas fa-university"
          value="transfer"
          small={true}
          active={payment_type === 'transfer'}
          clickFun={zeroPriceAlert ? undefined : selectPayemntType}
          disabled={zeroPriceAlert}
          id="click_payment_transfer"
        />
        <RichButton
          title="Paga con PayPal"
          classes="paypal_btn"
          icon="fa-fw fab fa-cc-paypal "
          value="paypal"
          small={true}
          active={payment_type === 'paypal'}
          clickFun={zeroPriceAlert ? undefined : selectPayemntType}
          disabled={zeroPriceAlert}
          id="click_payment_paypal"
        />
        <RichButton
          title="Paga a tu Propio Ritmo"
          classes={' atrato_btn ' + (total < 1000 || zeroPriceAlert ? 'disabled' : '')}
          value="atrato"
          small={true}
          active={payment_type === 'atrato'}
          clickFun={zeroPriceAlert ? undefined : selectPayemntType}
          disabled={total < 1000 || zeroPriceAlert}
          id="click_payment_atrato"
        >
          <img src={atrato_logo} alt="Paga con Atrato" />
          {total < 1000 ? (
            <div className="small">Solo en compras mayores de $1,000 MXN</div>
          ) : null}
        </RichButton>

        {/* Coppel pay disabled */}
        {/* <RichButton
          title="Usa tu crédito Coppel"
          classes={'coppel_btn' + (total > 15000 ? 'disabled' : '')}
          small={true}
          icon=""
          value="coppel"
          active={payment_type === 'coppel'}
          clickFun={selectPayemntType}
          disabled={total > 15000}
          id="click_payment_coppel"
        >
          <img src={coppelpay_logo} alt="Paga con Coppel Pay" />
          {total > 15000 ? (
            <div className="small">Solo compras de hasta $15,000 MXN</div>
          ) : null}
        </RichButton> */}
      </div>

      <div className="text-center mt-3">
        {/* <small className="d-block text-muted mt-1">
          {' '}
          <i
            className="fa fa-check-circle text-success pr-1"
            aria-hidden="true"
          ></i>{' '}
          Tus pagos se realizan de forma segura con encriptación de 256 bits{' '}
        </small> */}
        {isDelivery && (
          <div className="delivery-info">
            <div className="d-flex">
              <i
                className="fas fa-info-circle mt-1 pr-2"
                aria-hidden="true"
              ></i>
              <span>
                El costo del flete puede variar según factores como el volumen,
                peso o distancia del envío.
                <br />
                Te notificaremos de cualquier ajuste antes de procesar tu
                pedido.
              </span>
            </div>
          </div>
        )}
      </div>
      {payment_type === 'transfer' && <TransferPayment />}

      {payment_type && (
        <React.Fragment>
          {error_message && (
            <div className="alert alert-danger" role="alert">
              <p>
                <i className="fas fa-exclamation-triangle"></i> {error_message}
              </p>
            </div>
          )}
          <button
            className="btn btn-dark text-capitalize py-4 py-md-3 btn-payment fixed"
            data-next="resume"
            onClick={clickFun}
            disabled={zeroPriceAlert}
          >
            Continuar
          </button>
          <p className="text-center">
            <small className="d-block text-muted mt-1">
              {' '}
              <i
                className="fa fa-check-circle text-success"
                aria-hidden="true"
              ></i>{' '}
              Tus pagos se realizan de forma segura con encriptación de 256
              bits{' '}
            </small>
          </p>
          <small className="text-help mt-2 d-block text-muted">
            Necesitas ayuda con tu pedido o tienes dudas? <br />
            Estámos para atenderte en el correo <b>servicio@mathasa.com.mx</b> o
            al teléfono <b>614-442-9000</b>
          </small>
        </React.Fragment>
      )}
    </div>
  );
};

export const InfoSection: React.FC<InfoSectionProps> = ({
  clickFun,
  loading,
  products,
  removeFun,
  shippingcost,
  branches,
  delivery_type,
  changePriceAlert,
  zeroPriceAlert = false,
  zip,
  onPickUpMsgChange,
}) => {
  const [disabled_btn, setDisabled_btn] = useState<boolean>(false);

  const disableButton = () => {
    setDisabled_btn(true);
  };

  const setRemoveFun = () => {
    removeFun();
    setDisabled_btn(false);
  };

  if (loading || !shippingcost.shippingCosts) {
    return (
      <div className="col-md-6">
        <Loader
          half
          txt={
            !shippingcost.shippingCosts
              ? delivery_type === 'shipping'
                ? 'Calculando costos de envío...'
                : 'Consultando inventario...'
              : 'Cargando'
          }
        />
      </div>
    );
  }
  return (
    <div className="payment_section col-md-8">
      <ShippingCosts
        removeFun={setRemoveFun}
        products={products}
        changePriceAlert={changePriceAlert}
        zeroPriceAlert={zeroPriceAlert}
        shippingcost={shippingcost}
        branches={branches}
        delivery_type={delivery_type}
        zip={zip}
        disableButton={disableButton}
        goToAddress={clickFun}
        onPickUpMsgChange={onPickUpMsgChange}
      />
      <Survey />
    </div>
  );
};

const TransferPayment = () => (
  <div className="transfer_data my-5">
    <p>Datos de Pago</p>
    <table className="table">
      <thead>
        <tr>
          <th>Banco</th>
          <th>CLABE</th>
          <th>Nombre</th>
          <th>Referencia</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Banregio</td>
          <td>058 150 6004 1980 0122</td>
          <td>Mathasa S.A. de C.V.</td>
          <td className="text-muted">Se te enviará por correo</td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default { PaymentSection, InfoSection };
